
import Vue from 'vue'
// import QuotationTransformer from '@/transformers/purchase/quotation'
import errorHandler from '@/utils/errorHandler'

export default (affectedId, suppliesList) => {
	const request = errorHandler(
		Vue.$http.post('purchase/materialsquotation/', {
			authorized_project: affectedId,
			list_supply: suppliesList,
		})
	)

	return request.then(response => response.data)
}


// WEBPACK FOOTER //
// ./src/services/purchase/sendQuotation.js